import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

export class InvoiceService extends SearchService {
    static baseURL = 'invoice-data'

    static create(payload) {
        return AxiosService.post(`${this.baseURL}`, payload).then(
            ({ data }) => data
        )
    }
}
